import cn from 'classnames';
import useTranslationAndTypograph from 'hooks/useTranslationAndTypograph';
import React from 'react';

import { CircularProgress } from 'components/basic/Loaders';
import { BodyM, H1, H3, H4 } from 'components/basic/Typography';
import Page from 'components/layouts/Page';
import WelltoryProLogo from 'components/pagesComponents/payments/PlansPage/WelltoryProLogo';

import { useAppSelector } from 'redux-store';

import getAuthRedirectUrl from 'utils/getAuthRedirectUrl';

import s from './LifetimeUserPlan.module.scss';

export default function UserPlan(): JSX.Element {
  const t = useTranslationAndTypograph();
  const { isFetched, products } = useAppSelector(state => state.products);
  const { profile } = useAppSelector(state => state.profile);

  getAuthRedirectUrl(profile);
  if (!isFetched) {
    return <CircularProgress />;
  }

  const [product] = products;
  const { title } = product;

  return (
    <Page>
      <WelltoryProLogo />
      <H1 className={cn(s.h1, 'mb-4 cy-plans-title')}>{t('We’re all set')}</H1>
      <H4 className={cn(s.h4, 'mb-10')}>
        {t(
          'Take full advantage of the app. The more you use it, the more helpful it becomes',
        )}
      </H4>

      <div className={cn(s.product, 'cy-lifetime-plan')}>
        <div className={s.productHead}>
          <H3 Tag="div">{title}</H3>
        </div>
        <BodyM className={s.description}>{t('Your current plan')}</BodyM>
      </div>
    </Page>
  );
}
